module.exports = __webpack_public_path__ + "static/media/996059.cddda43f.png";